<script>
import { Row, Col, Cell, Image, Icon, Tag, Grid, GridItem, List, Toast, Empty, Dialog, Popup } from 'vant'
import { QNImageUtil } from '@/fcl/utils'
import { getToken } from '@/fcl/libs/cookie-storage'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-organization-manage',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-row': Row,
        'van-col': Col,
        'van-cell': Cell,
        'van-image': Image,
        'van-icon': Icon,
        'van-tag': Tag,
        'van-grid': Grid,
        'van-grid-item': GridItem,
        'van-list': List,
        'van-empty': Empty,
        'van-popup': Popup,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            organizationManager: {
                organization: {
                    id: null,
                    name: null,
                    logoUrl: null,
                    duration: null,
                    area: null,
                    areaId: null,
                    authStatus: null,
                    type: null,
                    typeLabel: null,
                },
                matchList: null,
                role: {
                    isManager: null,
                    isMatchManager: null,
                    isReferee: null,
                    isOrganizationManager: null,
                    isStaffManager: null,
                    isRefereeManager: null,
                    isEventManager: null,
                },
            },
            showGoPC: null,
            locale: {}
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        organizationCheckInPeriod() {
            let label = ''
            if (this.organizationManager.organization.duration) {
                label = this.locale.localeProp('check-in-period', this.organizationManager.organization.duration)
            }
            return label
        },
        isMatchListEmtpy() {
            return this.organizationManager.matchList 
                && (this.organizationManager.matchList.length == 0)
        },
        showAccount() {
            // return this.isManager()
            // @tmp hide the accout section 
            return false
        },
        showBasicFeature() {
            return this.isBasicEdition()
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        goWebappBmb(target){
          var baseUrl = process.env.VUE_APP_ENV == 'prod' ? 'https://www.snsports.cn/webapp-bmb/index.html' : 'https://www.snsports.cn/webapp-bmb-stage/index.html'
          let joinSignal = '&'
          if (target.indexOf('?') == -1) {
              joinSignal = '?'
          }
          console.log('joinSignal', joinSignal)
          window.location.href = baseUrl + target + joinSignal + `passport=${getToken()}`;
        },
        goWebapp(target){
          var baseUrl = process.env.VUE_APP_REPORT_URL + '?redirect=';
          window.location.href = baseUrl + target + `&passport=${getToken()}`;
        },
        onVideoServiceItemClick() {
            this.goWebappBmb('#/videoService/index?dsbridge=1')
        },
        onMatchInsuranceItemClick() {
            window.location.href = 'https://cpsh5.xiebao18.com/m/czh1007574/media-15005.html'
        },
        onDataStatsItemClick() {
            this.goWebapp('match-service&v=2&type=stats')
        },
        onClothingCustomizationItemClick() {
            this.goWebappBmb('#/activityPage/clothing')
        },
        onDerivativeCustomizationItemClick() {
            this.goWebappBmb('#/activityPage/customize/1')
        },
        onMPCustomizationItemClick() {
            this.goWebappBmb('#/activityPage/customize/2?v=1')
        },
        onExchangeBtnClick() {
            console.log('onExchangeBtnClick')
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgListOrganization'
                }
            })
        },
        onAuthStatusIconClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgDetailOrganization',
                    params: {
                        id: this.organizationManager.organization.id
                    },
                    query: {
                        tab: 1
                    }
                }
            })
        },
        onGoAccountBtnClick() {
            if (this.organizationManager.organization.authStatus == '1' 
                || this.organizationManager.organization.authStatus == '4') {
                Dialog.confirm({
                    title: this.locale['go-account'],
                    message: this.locale['go-auth-confirm-message'],
                    confirmButtonText: this.locale['go-auth'],
                }).then(() => {
                    // on confirm
                    // navigate to the organization detail page with auth tab
                    this.$emit('custom-event', {
                        type: 'navigate',
                        data: {
                            name: 'UserOrgDetailOrganization',
                            params: {
                                id: this.organizationManager.organization.id
                            },
                            query: {
                                tab: 1
                            }
                        }
                    })
                }).catch(() => {
                    // on cancel
                })
            }
        },
        onTodoItemClick() {
            Toast(this.locale['coming-soon'])
        },
        onTeamListItemClick() {
            if (this.isBasicEdition()) {
                if (!this.validateManager(this.organizationManager.role.isManager)) {
                    Toast(this.locale['qinglianxijigoushengjizhiguanliyuanchakan'])
                    return
                }
                this.goWebappBmb(`#/spoMyTeam?orgId=${this.organizationManager.organization.id}`)
            }
            else {
                this.onTodoItemClick()
            }
        },
        onVideoLibraryItemClick() {
            if (this.isBasicEdition()) {
                if (!this.validateManager(this.organizationManager.role.isManager)) {
                    return
                }
                this.goWebappBmb(`#/matchVideo?orgId=${this.organizationManager.organization.id}`)
            }
            else {
                this.onTodoItemClick()
            }
        },
        onMiniProgramItemClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    url: 'https://www.snsports.cn/webapp-bmb-stage/index.html#/activityPage/customize/2'
                }
            })
        },
        onServiceBtnClick() {
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    url: 'https://www.snsports.cn/webapplt/index/index.html#/customer-service/bd-agent'
                }
            })
        },
        onRefereeAdminItemClick() {
            if (!this.validateManager(this.organizationManager.role.isRefereeManager)) {
                return
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgListReferee',
                    query: {
                        organizationId: this.organizationManager.organization.id
                    }
                }
            })
        },
        onStaffAdminItemClick() {
            if (this.isBasicEdition()) {
                if (!this.validateManager(this.organizationManager.role.isManager)) {
                    return
                }
                this.goWebappBmb(`#/adminList?orgId=${this.organizationManager.organization.id}`)
            }
            else {
                if (!this.validateManager(this.organizationManager.role.isStaffManager)) {
                    return
                }
                this.$emit('custom-event', {
                    type: 'navigate',
                    data: {
                        name: 'UserOrgListStaff',
                        query: {
                            organizationId: this.organizationManager.organization.id
                        }
                    }
                })
            }
        },
        onOrgnizationInfoItemClick() {
            if (this.isBasicEdition()) {
                if (!this.validateManager(this.organizationManager.role.isManager)) {
                    return
                }
            }
            else {
                if (!this.validateManager(this.organizationManager.role.isOrganizationManager)) {
                    return
                }
            }
            this.$emit('custom-event', {
                type: 'navigate',
                data: {
                    name: 'UserOrgDetailOrganization',
                    query: {
                        organizationId: this.organizationManager.organization.id
                    }
                }
            })
        },
        onGoPCItemClick() {
            this.showGoPC = true
        },
        onGoPCPopupClick() {
            let url
            if (this.isBasicEdition()) {
                url = 'https://mc.banmabang.cn'
            }
            else {
                url = 'https://saas-v2.snsports.cn'
            }
            this.showGoPC = false
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url)
                Toast(this.locale['copy-succeed'])
            }
            else {
                Toast(this.locale['copy-failed'])
            }
        },
        onCreateMatchBtnClick() {
            if (this.isBasicEdition()) {
                window.location.href = `banmabang://quickapply?crmId=${this.organizationManager.organization.id}`
            }
            else {
                if (!this.validateManager(this.organizationManager.role.isEventManager)) {
                    return
                }
                this.onGoPCItemClick()
            }
        },
        onMatchItemClick(item) {
            if (item.isBangSaiShi > 0) {
                //这个是新的邦赛事-赛事后台
                // this.$emit('custom-event', {
                //     type: 'navigate',
                //     data: {
                //         name: 'OrgManageMatch',
                //         params: {
                //             id: item.id
                //         }
                //     }
                // })

                //这个是旧的, 线上的, 邦赛事-赛事后台
                this.$router.push('/match-manage/match-detail/' + item.id)
            } 
            else {
                if(item.id.startsWith('match')) {
                    const matchId = item.id.replace(/match_/g, '');
                    window.location.href = 'banmabang://matchmanage?matchId=' + matchId;
                } else {
                    window.location.href = 'banmabang://union?id=' + item.id;
                }
            }
        },
        matchStatusField(item) {
            return this.locale.localeProp('match-status-option-' 
                + (item.status ? item.status : '1'))
        },
        matchCheckInPeriod(item) {
            // console.log('matchCheckInPeriod', item.duration.num, item.duration.unit)
            let label = ''
            if (item.duration) {
                label = this.locale.localeProp('check-in-period', item.duration)
            }
            return label
        },
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateManager(prop) {
            // console.log('validateManager', prop)
            if (prop) {
                return true
            }
            else {
                Toast(this.locale['no-permission'])
                return false
            }
        },
        isBasicEdition() {
            return this.organizationManager.organization.type === 0
        },
    },
}
</script>

<template>
    <div class="organization-manage">
        <!--<div class="background"/>-->
        <div class="nav-op-bar fixed-top">
            <van-row class="hp100 vertical-center text-center">
                <van-col span="8">
                    <van-icon
                        class-prefix="iconfont"
                        name="service"
                        size="21"
                        @click="onServiceBtnClick"
                    />
                </van-col>
                <van-col span="8">
                    <van-icon
                        name="tv-o"
                        size="21"
                        @click="onGoPCItemClick"
                    />
                </van-col>
                <van-col span="8">
                    <van-icon
                        name="add-o"
                        size="21"
                        @click="onCreateMatchBtnClick"
                    />
                </van-col>
            </van-row>
        </div>
        <div class="head b-outer-margin">
            <van-cell class="u-inner-padding">
                <template #title>
                    <van-row type="flex">
                        <van-col class="vertical-center">
                            <van-image 
                                v-if="organizationManager.organization.logoUrl"
                                :src="adjustImageSize(organizationManager.organization.logoUrl, 68, 68)" 
                                round center
                                fit="cover" 
                                width="34px" 
                                height="34px"
                            />
                        </van-col>
                        <van-col class="name-field vertical-center">
                            <template #default>
                                <div class="wrapper u-outer-padding">
                                    <div>
                                        <span class="label block van-ellipsis">{{ organizationManager.organization.name }}</span>
                                    </div>
                                    <div class="second-line vertical-center">
                                        <van-tag class="r-outer-margin">{{ organizationCheckInPeriod }}</van-tag>
                                        <van-tag class="r-outer-margin">{{ organizationManager.organization.typeLabel }}</van-tag>
                                        <!-- @tmp hide the authentication section -->
                                        <!--<div class="vertical-center" @click="onAuthStatusIconClick">
                                            <img v-if="organizationManager.organization.authStatus == '1'" src="@/fcl/assets/user/auth-status-init-icon.svg"/>
                                            <img v-else-if="organizationManager.organization.authStatus == '2'" src="@/fcl/assets/user/auth-status-checking-icon.svg"/>
                                            <img v-else-if="organizationManager.organization.authStatus == '3'" src="@/fcl/assets/user/auth-status-passed-icon.svg"/>
                                            <img v-else-if="organizationManager.organization.authStatus == '4'" src="@/fcl/assets/user/auth-status-failed-icon.svg"/>
                                        </div>-->
                                    </div>
                                </div>
                            </template>
                        </van-col>    
                        <van-col class="vertical-center">
                            <van-icon 
                                class="exchange-icon" 
                                name="exchange"
                                @click="onExchangeBtnClick"
                            />
                        </van-col>
                    </van-row>
                </template>
            </van-cell>
        </div>
        <div v-if="showAccount" class="b-outer-margin">
            <van-cell 
                class="u-inner-padding"
                :title="locale['account']"
                is-link center
                @click="onGoAccountBtnClick"
            >
                <template #icon>
                    <img class="r-inner-margin" src="@/fcl/assets/user/account-symbol.svg"/>
                </template>
                <template #default>
                    <div class="h-outer-padding">
                        <div class="lh1">
                            <span class="minor-text main-secondary-color">{{ locale['go-account'] }}</span>
                        </div>
                        <div class="lh1">
                            <span class="support-text minor-color">{{ locale['go-account-description'] }}</span>
                        </div>
                    </div>
                </template>
            </van-cell>
        </div>
        <div class="added-service-grid grid-item-less-padding b-outer-margin bg-white">
            <div class="u-outer-padding no-padding-bottom">
            <div class="b-outer-padding relative">
                <span class="text-title">{{ locale['toolbox'] }}</span>
                <div class="full-separator-line-bottom"/>
            </div>
            </div>
            <van-grid :border="false" :column-num="5" class="small-text">
                <van-grid-item :text="locale['video-service']" @click="onVideoServiceItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-01.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['match-insurance']" @click="onMatchInsuranceItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-02.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['data-stats']" @click="onDataStatsItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-03.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['register-transfer']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-04.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['clothing-customization']" @click="onClothingCustomizationItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-05.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['derivative-customization']" @click="onDerivativeCustomizationItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-06.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['game-screen']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-07.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['mp-customization']" @click="onMPCustomizationItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-08.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['check-in']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-09.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['data-export']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/added-service-unit-10.png" style="width: 48px; height: 48px;"/>
                    </template>
                </van-grid-item>
            </van-grid>
        </div>
        <div v-if="showBasicFeature" class="functional-grid grid-item-less-padding b-outer-margin bg-white relative">
            <van-grid :border="false">
                <van-grid-item :text="locale['team-list']" @click="onTeamListItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/team-list-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['video-library']" @click="onVideoLibraryItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/video-library-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['staff-admin']" @click="onStaffAdminItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/staff-admin-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['mini-program']" @click="onMiniProgramItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/mini-program-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['organization-info']" @click="onOrgnizationInfoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/organization-info-icon.svg"/>
                    </template>
                </van-grid-item>
            </van-grid>
        </div>
        <div v-else class="functional-grid grid-item-less-padding b-outer-margin ">
            <van-grid :border="false">
                <van-grid-item :text="locale['team-list']" @click="onTeamListItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/team-list-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['video-library']" @click="onVideoLibraryItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/video-library-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['schedule-table']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/schedule-table-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['referee-admin']" @click="onRefereeAdminItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/referee-admin-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['staff-admin']" @click="onStaffAdminItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/staff-admin-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['asset-library']" @click="onTodoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/asset-library-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['mini-program']" @click="onMiniProgramItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/mini-program-icon.svg"/>
                    </template>
                </van-grid-item>
                <van-grid-item :text="locale['organization-info']" @click="onOrgnizationInfoItemClick">
                    <template #icon>
                        <img src="@/fcl/assets/user/organization-info-icon.svg"/>
                    </template>
                </van-grid-item>
            </van-grid>
        </div>
        <div class="match-list bg-white u-outer-padding">
            <div class="list-title b-outer-padding relative">
                <span class="text-title">{{ locale['match-list'] }}</span>
                <div class="full-separator-line-bottom"/>
            </div>
            <div v-if="!isMatchListEmtpy">
                <van-list>
                    <div
                        class="h-inner-padding van-hairline--bottom"
                        v-for="item in organizationManager.matchList"
                        :key="item.id"
                        @click="onMatchItemClick(item)"
                        >
                        <div class="match-name-unit b-inner-margin">
                            <span class="main-text">{{ item.name }}</span>
                            <span class="minor-text pull-right">
                                <van-tag>{{ matchStatusField(item) }}</van-tag>
                            </span>
                        </div>
                        <van-row class="match-info b-inner-margin">
                            <van-col class="r-outer-margin h50">
                                <van-image 
                                    v-if="item.logoUrl"
                                    :src="adjustImageSize(item.logoUrl, 100, 100)" 
                                    fit="cover" 
                                    width="50px" 
                                    height="50px"
                                />
                                <img
                                    v-else
                                    src="@/fcl/assets/user/logo-symbol.png"
                                    style="width: 50px; height: 50px;"
                                />
                            </van-col>
                            <van-col>
                                <div>
                                    <span class="minor-text minor-color r-outer-margin">{{ locale['sport-type-1'] }}</span>
                                    <span class="minor-text minor-color">{{ item.periodDate }}</span> 
                                </div>
                            </van-col>
                        </van-row>
                        <div class="tag-bar b-inner-padding">
                            <van-tag>{{ matchCheckInPeriod(item) }}</van-tag>
                        </div>
                    </div>
                </van-list>
            </div>
            <div v-else @click="onCreateMatchBtnClick">
                <van-empty 
                    :description="locale['match-empty-hint']"
                    image-size="0"
                >
                    <van-button round plain type="info" class="btn">{{ locale['create-now'] }}</van-button>
                </van-empty>
            </div>
        </div>
        <div class="branding-section text-center">
            <img src="@/fcl/assets/user/logo-bottom-grey.png"/>
        </div>
        <van-popup v-model="showGoPC">
            <div v-if="showBasicFeature" @click="onGoPCPopupClick">
                <img 
                    src="@/fcl/assets/user/go-pc-basic-edition.png" 
                    style="width: 283px; height: 307px;"
                />
            </div>
            <div v-else @click="onGoPCPopupClick">
                <img 
                    src="@/fcl/assets/user/go-pc-advanced-edition.png" 
                    style="width: 283px; height: 307px;"
                />
            </div>
        </van-popup>
    </div>
</template>

<style scoped>
.background {
    position: absolute;
    top: 0;
    width: 100%;
    height: 426px;
    background: linear-gradient(180deg, #E1EDF9 0%, rgba(225, 237, 249, 0) 100%);
}
.exchange-icon {
    position: absolute;
    right: 5px;
    padding: 15px;
}
.name-field .van-cell__value span {
    font-size: 16px;
}
.name-field .wrapper {
    padding-left: 6px;
}
.name-field .label {
    max-width: 280px;
}
.name-field .second-line {
    line-height: 1;
}
.branding-section {
    margin-top: 10px;
}
.branding-section img {
    width: 301px;
    height: 60px;
}
</style>
<style>
.organization-manage .van-empty__bottom {
    margin-top: 0;
}
.small-text .van-grid-item__text {
    font-size: 11px;
}
</style>